import { QuestionCategory, QuestionType } from "@/api/user/useGetMyQuestions";
import { QuestionnaireFlowQuestion } from "@/types/question.types";

export interface QuestionAnalysis {
  // Type-based flags
  isSelectSingleQuestion: boolean;
  isSelectMultipleQuestion: boolean;
  isSelectQuestion: boolean;
  isRangeQuestion: boolean;
  isTextQuestion: boolean;
  isDateQuestion: boolean;
  isSelectFromListQuestion: boolean;

  // Personal info specific flags
  isPersonalInfo: boolean;

  // Booleans for specific personal_info fields
  isNameField: boolean;
  isPhoneNumberField: boolean;
  isNicknameField: boolean;
  isNationalityField: boolean;
  isBirthdayField: boolean;
  isPasswordField: boolean;
  isEmailField: boolean;
}

const defaultAnalysis: QuestionAnalysis = {
  isSelectSingleQuestion: false,
  isSelectMultipleQuestion: false,
  isSelectQuestion: false,
  isRangeQuestion: false,
  isTextQuestion: false,
  isDateQuestion: false,
  isSelectFromListQuestion: false,
  isPersonalInfo: false,
  isNameField: false,
  isPhoneNumberField: false,
  isNicknameField: false,
  isNationalityField: false,
  isBirthdayField: false,
  isPasswordField: false,
  isEmailField: false,
};

export const analyzeQuestion = (
  currentQuestion: QuestionnaireFlowQuestion | undefined
): QuestionAnalysis => {
  if (!currentQuestion) {
    return defaultAnalysis;
  }

  const { type, slug, category } = currentQuestion;
  const isPersonalInfo = category === QuestionCategory.PERSONAL_INFO;

  return {
    isSelectSingleQuestion: type === QuestionType.SELECT_SINGLE,
    isSelectMultipleQuestion: type === QuestionType.SELECT_MULTIPLE,
    isSelectQuestion: type === QuestionType.SELECT_SINGLE || type === QuestionType.SELECT_MULTIPLE,
    isRangeQuestion: type === QuestionType.RANGE,
    isTextQuestion: type === QuestionType.TEXT,
    isDateQuestion: type === QuestionType.DATE,
    isSelectFromListQuestion: type === QuestionType.SELECT_FROM_LIST,

    isPersonalInfo,

    isNameField: slug === "name",
    isPhoneNumberField: slug === "phoneNumber",
    isNicknameField: slug === "nickname",
    isNationalityField: slug === "nationality",
    isBirthdayField: slug === "birthday",
    isPasswordField: slug === "password",
    isEmailField: slug === "email",
  };
};
